var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mp-wizard-step',[_c('p-row',[_c('p-col',{attrs:{"xs12":"","md9":"","lg6":"","xl5":""}},[_c('p',{staticClass:"pre-line"},[_vm._v(" "+_vm._s(_vm.$t('page.invoice.text.successfullyPayed'))+" ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }